import React, { Component } from 'react'
import Link from '../../utils/link'
import Sold from '../../assets/images/sold.svg'
import { Bed, Bath, Car, Land, Build } from '../icons'
import Fade from 'react-reveal/Fade'

class AgentPropertyCard extends Component {

  state = {
    popup: false
  }

  render() {
    const { slug, title, databaseId, propertyAddress, propertyImages, propertyData, propertyLand, propertyListing, postType, propertyType } = this.props
    const sold = propertyListing?.marketingStatus === 'Sold'
    let { popup } = this.state

    let pathName = `https://kollosche.com.au/${postType}/${slug}/`
    let heading = `${propertyAddress.streetAddress}<br />${propertyAddress.suburb} ${propertyAddress.postcode}`
    if (propertyAddress.hideAddress) {
      heading = propertyAddress.suburb
      pathName = `https://kollosche.com.au/${postType}/${propertyAddress.suburb.toLowerCase().replace(/ /gi, '-')}-${databaseId}/`
    }

    return (
      <div className={`property ${sold ? 'property--sold' : ''}`}>
        <div className='property__wrapper' onClick={() => this.setState({ popup: true })}>
          <div className='property__image'>
            <img src={propertyImages?.length > 0 && propertyImages[0].large} alt={title} />
            { sold && <img className='sold' src={Sold} alt='Sold' /> }
            <div className='property__rollover'>
              <div className='property__title'>
                <h4 dangerouslySetInnerHTML={{ __html: heading }} />
              </div>
              <div className='property__meta'>
                <span>{propertyListing?.displayPrice}</span>
                { propertyData.type !== 'Commercial' &&
                  <ul className='property__specs property__specs--desktop'>
                    { propertyData?.bedrooms > 0 && <li><Bed color={`#FFFFFF`} /> {propertyData?.bedrooms}</li> }
                    { propertyData?.bathrooms > 0 && <li><Bath color={`#FFFFFF`} /> {propertyData?.bathrooms}</li> }
                    { propertyData?.totalParking > 0 && <li><Car color={`#FFFFFF`} /> {propertyData?.totalParking}</li> }
                  </ul>
                }
                { propertyData.type === 'Commercial' &&
                  <ul className='property__specs property__specs--desktop property__specs--commercial'>
                    { propertyData?.totalParking > 0 && <li><Car color={`#FFFFFF`} /> {propertyData?.totalParking}</li> }
                    { propertyLand?.buildingArea_value && <li className='area'><Build color={`#FFFFFF`} /> {propertyLand.buildingArea_value}{propertyLand.buildingArea_unit === 'sqm' ? '㎡' : propertyLand.buildingArea_unit+'s'}</li> }
                    { propertyLand?.landArea_value && <li className='area'><Land color={`#FFFFFF`} /> {propertyLand.landArea_value}{propertyLand.landArea_unit === 'sqm' ? '㎡' : propertyLand.landArea_unit+'s'}</li> }
                  </ul>
                }
              </div>
            </div>
          </div>
          <div>
          { propertyData.type !== 'Commercial' &&
            <ul className='property__specs property__specs--mobile property__specs--commercial'>
              { propertyData?.bedrooms > 0 && <li><Bed color={`#FFFFFF`} /> {propertyData?.bedrooms}</li> }
              { propertyData?.bathrooms > 0 && <li><Bath color={`#FFFFFF`} /> {propertyData?.bathrooms}</li> }
              { propertyData?.totalParking > 0 && <li><Car color={`#FFFFFF`} /> {propertyData?.totalParking}</li> }
            </ul>
          }
          { propertyData.type === 'Commercial' &&
            <ul className='property__specs property__specs--mobile property__specs--commercial'>
              { propertyData?.totalParking > 0 && <li><Car color={`#FFFFFF`} /> {propertyData?.totalParking}</li> }
              { propertyLand?.buildingArea_value && <li className='area'><Build color={`#FFFFFF`} /> {propertyLand.buildingArea_value}{propertyLand.buildingArea_unit === 'sqm' ? '㎡' : propertyLand.buildingArea_unit+'s'}</li> }
              { propertyLand?.landArea_value && <li className='area'><Land color={`#FFFFFF`} /> {propertyLand.landArea_value}{propertyLand.landArea_unit === 'sqm' ? '㎡' : propertyLand.landArea_unit+'s'}</li> }
            </ul>
          }
          </div>
        </div>
        <div className={`property-popup ${popup ? 'active' : ''}`}>
          <div className='property-popup__wrapper'>
            <button type='button' className='property-popup__close' onClick={() => this.setState({ popup: false })}>Close</button>
            <div className='property-popup__inner'>
              <span className='property-popup__tag'>{ propertyData.category }</span>
              <div className='property-popup__title'>
                <h4 dangerouslySetInnerHTML={{ __html: heading }} />
              </div>
              <span className='property-popup__price'>{propertyListing?.displayPrice}</span>
              <div className='property-popup__meta'>
                <ul className='property-popup__specs'>
                  { propertyData?.bedrooms > 0 && <li><Bed color={`#233356`} /> {propertyData?.bedrooms}</li> }
                  { propertyData?.bathrooms > 0 && <li><Bath color={`#233356`} /> {propertyData?.bathrooms}</li> }
                  { propertyData?.totalParking > 0 && <li><Car color={`#233356`} /> {propertyData?.totalParking}</li> }
                </ul>
                <img src={propertyImages?.length > 0 && propertyImages[0].large} alt={title} />
              </div>
              <Link className='property-popup__button btn' to={pathName}>View Full Listing</Link>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default AgentPropertyCard
